
// add no-icon attribute to disable icons
export default {
  name: 'SecurityReportsCard',
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'pdf',
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    noDetail: {
      type: Boolean,
      default: false,
    },
  },
}
